import request from "@/utils/request";  //导入封装请求的js文件


//确认状态筛选条件

export function confirmStatus (data) {
  return request({
    url: "/condition/confirmStatus",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}
//平台筛选条件
export function platform (data) {
  return request({
    url: "/condition/platform",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//运营名称筛选条件
export function operatorName (data) {
  return request({
    url: "/condition/operatorName",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//分页获取商品详情
export function getlist (data) {
  return request({
    url: "/data/spu/list",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}


//编辑sku价格
export function editPrice (data) {
  return request({
    url: "/data/sku/editPrice",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//编辑主图
export function editMainImageText (data) {
  return request({
    url: "/data/spu/editMainImageText",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//编辑主图
export function editCoupon (data) {
  return request({
    url: "/data/spu/editCoupon",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//编辑主图
export function editLogistics (data) {
  return request({
    url: "/data/spu/editLogistics",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//编辑主图
export function sureconfirm (data) {
  return request({
    url: "/data/spu/confirm",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//编辑主图
export function refresh (data) {
  return request({
    url: "/data/spu/refresh",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//编辑主图
export function scorelist (data) {
  return request({
    url: "/store/score/list",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}



//编辑主图
export function scoreedit (data) {
  return request({
    url: "/store/score/edit",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//编辑主图
export function skulist (data) {
  return request({
    url: "/setting/task/list",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//编辑主图
export function skuNamelist (data) {
  return request({
    url: "/setting/skuName/list",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//编辑主图
export function skuNameedit (data) {
  return request({
    url: "/setting/skuId/edit",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}


//推荐主图文本列表
export function suggestMainImageText (data) {
  return request({
    url: "/data/spu/suggestMainImageText",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//新增运营人员
export function operatoradd (data) {
  return request({
    url: "/operator/add",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//运营名称下拉查询
export function operatorlist (data) {
  return request({
    url: "/operator/list",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//商品ID信息列表分页查询
export function spulist (data) {
  return request({
    url: "/operator/spu/list",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

//分配运营
export function operatorassign (data) {
  return request({
    url: "/operator/assign",
    method: "post",
    data,
    // post请求接口后面拼接参数
  });
}

